import script from "./NewsletterForm.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsletterForm.vue?vue&type=script&setup=true&lang=js"

import "./NewsletterForm.vue?vue&type=style&index=0&id=28152d2d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28152d2d"]])

export default __exports__